<div mat-dialog-content class="dialog-content text-center">
  <div class="icon-wrapper">
    <mat-icon class="delete-icon">task_alt</mat-icon>
  </div>

  <h2 class="dialog-title">Approve {{ data.jobTitle }}?</h2>
  <p class="dialog-message">
    This job from {{ data.companyName }} will be published and visible to
    candidates immediately.
  </p>

  <div mat-dialog-actions align="center" class="dialog-actions">
    <button class="btn btn-color" (click)="closeDialog()">Cancel</button>
    <button class="btn btn-confirm ms-3" (click)="confirmApproval()">
      Confirm Approval
    </button>
  </div>
</div>
